import React from 'react';
import PropTypes from 'prop-types';
import ControlPanelButton from 'components/atoms/controlPanelButton';
import CallIcon from 'components/atoms/icons/callIcon';
import classNames from 'classnames';

const InteractionStatusButton = ({
  label = 'Monthly Interaction (Phone/SMS)',
  loading,
  handleClick,
  status,
  disabled = false,
}) => (
  <ControlPanelButton
    label={label}
    bracketLabel={status ? 'Yes' : 'No'}
    loading={loading}
    icon={CallIcon}
    disabled={loading || status === true || disabled}
    handleClick={handleClick}
    className={classNames(
      !disabled && {
        'red-border': !loading && status === false,
      },
    )}
  />
);

InteractionStatusButton.propTypes = {
  label: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  status: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default InteractionStatusButton;
